import axios from '@/libs/api.request'
import config from '@/config'

const baseUrl = config.s3Api + '/api/'

export const uploadFileUrl = baseUrl + 'upload_file'

export const getBuckets = (params) => {
  return axios.request({
    url: baseUrl + 'query_buckets',
    params: params,
    method: 'get'
  })
}

export const createBucket = (data) => {
  return axios.request({
    url: baseUrl + 'create_bucket',
    data: data,
    method: 'post'
  })
}

export const getFileLists = (params) => {
  return axios.request({
    url: baseUrl + 'query_dirs',
    params: params,
    method: 'get'
  })
}

export const getAllDirLists = (params) => {
  return axios.request({
    url: baseUrl + 'query_dirs_all',
    params: params,
    method: 'get'
  })
}

export const createDir = (data) => {
  return axios.request({
    url: baseUrl + 'create_dir',
    data: data,
    method: 'post'
  })
}

export const deleteFile = (data) => {
  return axios.request({
    url: baseUrl + 'delete_file',
    data: data,
    method: 'post'
  })
}

export const downloadFile = (params) => {
  return axios.request({
    url: baseUrl + 'generate_download_url',
    params: params,
    method: 'get'
  })
}

export const fileVersions = (params) => {
  return axios.request({
    url: baseUrl + 'get_object_versions',
    params: params,
    method: 'get'
  })
}

export const getFileAcl = (params) => {
  return axios.request({
    url: baseUrl + 'get_acl',
    params: params,
    method: 'get'
  })
}

export const getRate = (params) => {
  return axios.request({
    url: baseUrl + 'obj_sync_rate',
    params: params,
    method: 'get'
  })
}

// 回收站
export const getDeleteFileLists = (params) => {
  return axios.request({
    url: baseUrl + 'query_obj_deleted',
    params: params,
    method: 'get'
  })
}

// 还原删除的文件
export const restoreObjDeleted = (data) => {
  return axios.request({
    url: baseUrl + 'restore_obj_deleted',
    data: data,
    method: 'post'
  })
}

// 还原删除的文件
export const deleteObjForever = (data) => {
  return axios.request({
    url: baseUrl + 'delete_obj_forever',
    data: data,
    method: 'post'
  })
}
